import React from 'react';
import styled from 'styled-components';
import { Search } from '../components/Search';
import { ProductCard } from '../components/ProductCard';
import { Money } from 'shared/build/Money';
import { CategoriesNavigation } from '../components/CategoriesNavigation';
import { useQuery } from 'react-query';
import { WebsiteHome } from 'shared/build/types';
import { customFetch } from '../util/functions';
import { ScreenSizesPx } from '../util/styles';
import { useMediaQuery } from 'react-responsive';
import { useAuthentication } from '../context/AuthenticationProvider';
import { useGiftees } from '../context/GifteesProvider';
import { Redirect } from 'react-router-dom';

const ScWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ScProductList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
`;

export const Home = () => {
  const { user } = useAuthentication();
  const { shouldGuessGender } = useGiftees();

  const { data: homeData } = useQuery<WebsiteHome, string>(
    'website-home-get',
    async (): Promise<WebsiteHome> => {
      const response = await customFetch(`/api/website/home`);
      if (response.ok) {
        return response.json();
      }
      throw new Error('exploded');
    }
  );

  const isMediumScreen = useMediaQuery({
    query: `(min-width: ${ScreenSizesPx.small + 1}px)`,
  });

  if (!user) return null;

  if (!user.selectedGender && shouldGuessGender) {
    return <Redirect to="/adivinhe-o-genero" />;
  }

  return (
    <ScWrapper className="babys-page-padding">
      <Search goesToProducts={true} />
      <CategoriesNavigation />
      <ScProductList>
        {homeData?.products.map((p) => (
          <ProductCard
            description={p.title}
            productId={p.id}
            key={p.id}
            price={new Money(p.pricing[user.currency], user.currency)}
            imageId={p.imagesIds[0]}
            origin="Início"
          />
        ))}
      </ScProductList>
    </ScWrapper>
  );
};
